export enum LayoutMode {
  GRID = 'grid',
  LIST = 'list',
  COMPACT_LIST = 'compact_list',
  TABLE = 'table',
}
